import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useActiveVehicle } from '../../context/ActiveVehicleProvider';
import { TicketType } from '../../types/ticket';
import { useTicketTypeMeta } from '../../context/TicketTerminologyProvider';

const TICKET_TYPES: TicketType[] = ['log', 'logAndWarn', 'tow'];

const ChangeTicketTypeMenu: React.FC = () => {
	const { ticketFormMethods } = useActiveVehicle();
	const getTicketTypeMeta = useTicketTypeMeta();
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleSelect = (type: TicketType) => {
		ticketFormMethods.setValue('ticketType', type);
		handleClose();
	};

	return (
		<>
			<Tooltip title="Change action">
				<IconButton
					size="small"
					onClick={handleOpen}
					sx={{ border: 1, borderColor: 'divider' }}
				>
					<MoreVertIcon fontSize="small" />
				</IconButton>
			</Tooltip>
			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
				transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			>
				{TICKET_TYPES.map((type) => {
					const { buttonText } = getTicketTypeMeta(type);
					return (
						<MenuItem key={type} onClick={() => handleSelect(type)}>
							{buttonText}
						</MenuItem>
					);
				})}
			</Menu>
		</>
	);
};

export default ChangeTicketTypeMenu;
